import { computed } from 'vue';
import { useQuery, useQueryCache } from '@zoomcatalog/query-client';
import { AxiosError } from 'axios';

import api from '@/config/axios';
import { GET_USER_COMPANIES } from '@/config/endpoints';
import { useSelector } from '@/store/rootStore';

export type FetchUserComaniesResponse = {
  res: Array<UserCompany>;
};

export type UserCompany = {
  avatar: string;
  brand: {
    primary_color: string;
    square_logo_url: string;
  };
  city: string;
  company_id: string;
  'company_relationship.typ': string;
  country: string;
  created_at: string;
  description: string;
  domain: string;
  global_typ: string;
  is_active: 1 | 0;
  is_admin: 1 | 0;
  is_merged: 1 | 0;
  is_supplier: 1 | 0;
  is_zoomcatalog: 1 | 0;
  logo: string;
  name: string;
  phone: string;
  role_name: string;
  slug: string;
  typ: string;
  updated_at: string;
  website: string;
};

type UserCompaniesQueryContext = {
  options: {
    companyId: string | undefined;
  };
  handlers?: {
    onSuccess?(data: Array<UserCompany>): void;
  };
};
export function useUserCompaniesQuery(context?: UserCompaniesQueryContext) {
  const endpoints = useSelector((state) => state.sniffer.endpoints);

  // TODO: Add filter by company id
  return useQuery<Array<UserCompany>, AxiosError>('user_companies', {
    queryFn: async () =>
      api
        .get<FetchUserComaniesResponse>(GET_USER_COMPANIES.endpoint, {
          baseURL: endpoints.value.COMPANIES_API_ENDPOINT,
        })
        .then((data) => data.data.res),
    onSuccess(data) {
      context?.handlers?.onSuccess?.(data);
    },
    enabled: computed(() => Boolean(context?.options.companyId)),
    staleTime: Infinity,
    refetchOnMount: false,
  });
}

export function useInvalidateUserCompaniesQuery() {
  const cache = useQueryCache();
  return async () => cache.invalidateQueries('user_companies');
}
